module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradOutlineW01-Rg.ttf?d1370d61a5004d7baab8f21ba4832315";